/*
Copyright (c) 2020 by Stevie. All Rights Reserved.
*/
import NetworkFactory from '../libs/network/network-factory'

import AuthApi from './auth'
import AdminApi from './admin'
import HorseApi from './horse'
import * as Base from '../model/response'


const networkFactory = new NetworkFactory()
const net = networkFactory.makeNetwork()

export const auth = AuthApi(net)
export const admin = AdminApi(net)
export const horse = HorseApi(net)
export interface ListAPI<T> {
  list: (data?: any) => Promise<Base.PageObj<T> | undefined>,
  get: (id?: any) => Promise<T | undefined>,
  add: (id?: any) => Promise<any>,
  update: (params?: any) => Promise<any>,
  delete: (id?: any) => Promise<any>,
}

export type SearchAPI<T> = (data: any) => Promise<Base.PageObj<T> | undefined>

//interface
export type { IUsr, ITools, IHistory } from './admin'
export type { IHorse, IHorseVisit, Profile, Contact, Files, ShareKey, Orders, Preview, Calendar, CalendarUpdate } from './horse'